<template functional>
  <div class="event-gantt-card strong">
    <div
      v-for="event in [props.data]"
      :key="event.id"
      class="event-vertical-card"
      style="min-width: 150px !important"
    >
      <div
        :class="`px-3 py-1 ${event.discipline.name} elevation-2`"
        style="height: 49px; border-radius: 5px 5px 0 0"
      >
        <div class="white--text mb-1" style="text-transform: capitalize">
          {{ parent.$t("common:discipline." + event.discipline.name) }}
          <AppShowEventReferenceCode
            :event="event"
            force-current-color
            class="event-gantt-card-reference-code"
            ><template #prepend> | </template></AppShowEventReferenceCode
          >
        </div>
        <div>
          <AppShowEventStatus :event="event" no-button block always-show />
        </div>
      </div>

      <div
        class="py-2 px-3 event-vertical-card--content white elevation-2"
        style="position: relatve; top: -10px; border-radius: 5px"
      >
        <div class="mb-2" style="position: relative">
          <div>
            {{ parent.$dayjs.nicerDate(event.startDate, event.endDate) }}
          </div>
          <div class="d-flex">
            <div class="mr-1">
              <span
                :class="`flag-icon fi-${event.country.alpha2.toLowerCase()}`"
              />
            </div>
            <div>
              {{ event.country.ioc }},
              {{ event.region ? event.region.name : "" }},
              {{ event.place }}
            </div>
          </div>
        </div>

        <div class="mb-2">
          <div class="mb-2">
            <b>
              <AppShowEventName :event="event" disable-link />
              <v-icon
                v-if="event.isHighlighted"
                class="star-icon"
                color="star"
                style="font-size: 12px"
                >$iconStar</v-icon
              >
            </b>
          </div>

          <div>
            {{ event.organiser.name }}
            <template v-if="event.hostOrganisation">
              | {{ event.hostOrganisation.name }}</template
            >
          </div>
        </div>

        <div class="text-center secondary--text">
          <div>
            <AppShowEventCategories
              :event-categories="event.eventCategories"
              class="mb-2"
            />

            <AppShowProfQualificationsList
              :prof-qualifications="event.profQualifications"
              cut-off-list
              class="mb-2"
            />

            <AppShowCompetitionLevelNames
              :value="event.competitionLevels"
              class="mb-2"
            />

            <AppShowDifficultyLevels
              v-if="event.competitions"
              range
              class="mb-2"
              :value="event.competitions.map(c => c.difficultyLevel)"
            />

            <AppShowEventcodes :value="event.competitions" class="mb-2" />
          </div>
          <AppShowEventCupComponent
            v-if="event.cups && event.cups.length > 0"
            :event="event"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "EventGanttCard",
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>
<style scoped>
.event-gantt-card {
  position: absolute;
  min-height: 120px;
  width: 180px;
  padding: 4px;
  z-index: 10;
  top: 0;
  right: 0;
  border-radius: 0;
  transform: translate(190px, -130px);
  font-size: 11px;
  box-shadow: 0 0 2px 0 #0068b6;
}
</style>
<style>
.event-gantt-card-reference-code span,
.event-gantt-card-reference-code a {
  color: white !important;
  font-size: 11px !important;
}
</style>
